import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  constructor(private _snackBar: MatSnackBar) { }

  onOpenSnackbar(message: string, duration: number = 3000, action?: string){
    const snackBarRef =  this._snackBar.open(message, action, {
      duration
    });
    return snackBarRef;
  }
}
